import { Component, OnInit, Inject } from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {

  userName:string = 'Anandraj Asokan';

  constructor() { }

  ngOnInit(): void {
   
  }

  handleRedirectResponse(resp) {
    
  }

}
